export default __webpack_public_path__ + "static/aqua-2-2aaac08bf69bd1e946bedab611044658.jpg";